import { useEffect } from 'react';

import { useGetMany } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { TransactionType, TransactionTypeAliases } from 'types/embedded/transactionType';

export const useAutoCreateRefundAndChargeback = () => {
  const { watch, setValue } = useFormContext();

  const transactionTypesWatched = watch('transactionTypes');
  const { data: transactionTypes = [] } = useGetMany<TransactionType>(
    'transaction_types',
    {
      ids: transactionTypesWatched ?? [],
    },
    {
      enabled: Boolean(transactionTypesWatched?.length),
    },
  );

  const hasPaymentTransactionType = transactionTypes.some(
    (type) => type.alias === TransactionTypeAliases.Payment,
  );

  const isAutoCreateRefundAndChargebackEnabled = hasPaymentTransactionType;

  useEffect(() => {
    if (!hasPaymentTransactionType) {
      setValue('createRelatedPaymentCommissions', false);
    }
  }, [hasPaymentTransactionType, setValue]);

  return { isAutoCreateRefundAndChargebackEnabled };
};
